<span class="form-check {{ containerClass }}">
  @if (labelPosition === 'before' && !hideLabel) {
    <label class="form-check-label" style="cursor: pointer" [for]="labelFor || checkboxId">
      <ng-content></ng-content>
    </label>
  }
  <input
    type="checkbox"
    class="form-check-input {{ checkboxDisabled ? 'disabled' : '' }}"
    style="cursor: pointer"
    [id]="checkboxId"
    [attr.data-cy]="checkboxId"
    [indeterminate]="checkboxIndeterminate"
    [(ngModel)]="isChecked"
    [disabled]="checkboxDisabled"
    (change)="onCheckboxChange($event)"
    (blur)="onTouched()" />

  @if (labelPosition === 'after' && !hideLabel) {
    <label class="form-check-label" style="cursor: pointer" [for]="labelFor || checkboxId">
      <ng-content></ng-content>
    </label>
  }
</span>
